module.exports = __webpack_public_path__ + "static/media/login-background1-tw.d61b4615.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login/login-background1-tw.png
// module id = 1096
// module chunks = 110